// Shared builders for BeatEngine extra-case libraries — keep cases compact & consistent.
// choice beat (3 options, /full) and multi beat (chips, /max). Scores sum to /100 per case.
export const C = (key, label, title, prompt, options, full = 20, last = false) =>
  ({ type: "choice", key, label, title, prompt, options, full, ...(last ? { last: true } : {}) });
export const M = (key, label, title, prompt, chips, max = 20, last = false) =>
  ({ type: "multi", key, label, title, prompt, chips, max, ...(last ? { last: true } : {}) });
export const ok = (t, note) => ({ t, score: 3, note });
export const mid = (t, note) => ({ t, score: 1, note });
export const no = (t, note) => ({ t, score: 0, note });
export const yes = (t, coach) => ({ t, flag: true, coach });
export const trap = (t) => ({ t, flag: false, coach: "" });
